// extracted by mini-css-extract-plugin
export var columnedSection = "LinkSection-module__columnedSection___dvtl7";
export var container = "LinkSection-module__container___Bcuvw";
export var header = "LinkSection-module__header___YHkBG";
export var link = "LinkSection-module__link___nzgNW";
export var linksColumn = "LinkSection-module__linksColumn___NgDfA";
export var listItem = "LinkSection-module__listItem___CEreg";